import React, { Component, Fragment } from 'react';
import { momentLocalizer, Calendar as BigCalendar } from 'react-big-calendar';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EventCalendarDetail from './EventCalendarDetail';
import EventCalendarDay from './EventCalendarDay';
import { Agenda } from '../../../../assets/images/index';
import {
  StyledTitleWidget,
  StyledWrapper,
  StyledMonthHeader,
  BigWrapper
} from '../../core/Calendar/style';
import { EventCalendarModel } from '../../../model/events';
import {
  loadCalendarEvents,
  showDailyEvent,
  showDetailEvent,
  showDirectDetailEvent,
  hideDetailEvent
} from '../../../actions/events';
import Event from './Event';
import EventsCalendarHeader from './EventsCalendarHeader';
import FormattedDay from './FormattedDay';

import Loading from '../../core/Loading';
import { StyledLoadingContainer } from './style';

import { getEvent } from '../../../utils/apiEvents';

// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-unresolved
import '!!style-loader!css-loader!react-big-calendar/lib/css/react-big-calendar.css';
// eslint-disable-next-line import/no-webpack-loader-syntax,import/no-unresolved
import '!!style-loader!css-loader!./events.css';

const localizer = momentLocalizer(moment);

/**
 * Component for showing the month header weekend in gray
 */
const FormattedMonthHeader = ({ label, date }) => {
  const newLabel =
    window.screen.width >= 600
      ? moment(date)
          .locale('es')
          .format('dddd')
      : label;
  if (date.getDay() === 6 || date.getDay() === 0) {
    return (
      <StyledMonthHeader weekend className="weekday weekday--weekend">
        {newLabel}
      </StyledMonthHeader>
    );
  }
  return <StyledMonthHeader className="weekday">{newLabel}</StyledMonthHeader>;
};

FormattedMonthHeader.propTypes = {
  label: PropTypes.string,
  date: PropTypes.instanceOf(Date)
};

const customComponents = {
  event: Event,
  toolbar: EventsCalendarHeader,
  month: {
    header: FormattedMonthHeader,
    dateHeader: FormattedDay
  }
};

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      daySelected: this.props.location?.state?.day || null
    };
  }

  componentDidMount() {
    const {
      match: {
        params: { id }
      },
      location,
      selectedDate
    } = this.props;
    const day = location?.state?.day || null;
    if (id) {
      getEvent(id).then(response => {
        this.loadEventsHandler(new Date(day || response.startDate), response);
      });
    } else {
      this.loadEventsHandler(selectedDate, null);
    }
  }

  static getDerivedStateFromProps(props, state) {
    const {
      match: {
        params: { id: nextId }
      },
      location
    } = props;
    const day = location?.state?.day || null;

    if (
      props?.match?.params?.id !== state?.match?.params?.id ||
      props?.location?.state?.day !== state?.location?.state?.day
    ) {
      getEvent(nextId).then(response => {
        this.loadEventsHandler(new Date(day || response.startDate, response));
        this.setState({
          isLoading: false
        });
      });
    }

    return (
      {
        match: props.match,
        location: props.location
      } || null
    );
  }

  componentWillUnmount() {
    this.props.hideEvent();
  }

  loadEventsHandler = (date, event) => {
    const { loadEvents, showDirectDetail } = this.props;

    const fromDate = new Date(date);

    fromDate.setDate(1);
    fromDate.setUTCHours(0, 0, 0, 0);

    const toDate = new Date(fromDate);
    toDate.setMonth(toDate.getMonth() + 1);

    // const daySelected = id ? `${date.getDate()}` : null;
    loadEvents(fromDate, toDate, event?.start).then(() => {
      if (event) {
        showDirectDetail(event);
      }
      this.setState({
        isLoading: false
      });
    });
  };

  navigateEvent = event => {
    this.setState({ daySelected: event.start });
    this.loadEventsHandler(event.start, event);
  };

  render() {
    const {
      events,
      selectedDate,
      showDayEvent,
      showEventDetail,
      className
    } = this.props;
    const { daySelected } = this.state;

    return (
      <BigWrapper className={className}>
        <StyledTitleWidget
          title="agenda"
          type="agenda"
          icon={Agenda}
          small
          className="title"
        />
        <StyledWrapper className="wrapper-calendar">
          {this.state.isLoading ? (
            <StyledLoadingContainer>
              <Loading size="xl" />
            </StyledLoadingContainer>
          ) : (
            <Fragment>
              <BigCalendar
                localizer={localizer}
                culture="es"
                events={events}
                popup
                selectable
                components={customComponents}
                views={{
                  month: true
                }}
                date={selectedDate}
                onNavigate={() => {}} // Prop to avoid warning
                onSelectSlot={slot => showDayEvent(slot)}
                onSelectEvent={event => this.navigateEvent(event)}
                messages={{
                  showMore: count => `...${count} más`
                }}
                className="calendar"
              />
              {showEventDetail && (
                <EventCalendarDetail daySelected={daySelected} />
              )}
              <EventCalendarDay showEventDetail={showEventDetail} />
            </Fragment>
          )}
        </StyledWrapper>
      </BigWrapper>
    );
  }
}

Calendar.propTypes = {
  events: PropTypes.arrayOf(EventCalendarModel),
  selectedDate: PropTypes.instanceOf(Date),
  loadEvents: PropTypes.func,
  showDayEvent: PropTypes.func,
  className: PropTypes.string
};

const mapStateToProps = ({ events }) => ({
  events: events.events,
  selectedDate: events.selectedDate,
  showDayDetail: events.showDayDetail,
  showEventDetail: events.showEventDetail,
  hideEvent: PropTypes.func
});

const mapDispatchToProps = dispatch => ({
  loadEvents: (fromDate, toDate, day) =>
    loadCalendarEvents(dispatch, fromDate, toDate, null, day),
  showDayEvent: slot => showDailyEvent(dispatch, slot),
  showDetail: event => showDetailEvent(dispatch, event),
  showDirectDetail: event => showDirectDetailEvent(dispatch, event),
  hideEvent: () => hideDetailEvent(dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
